angular.
module("dx.webapp.invigilator").
controller("DxInvigilatorController", function InvigilatorController(
	$scope,
	$http,
	$q,

	PermissionShareEnum,
	validationService,
	DX_INVIGILATOR_SETTINGS,
	DX_INVIGILATOR_LOCATION_CONSTANTS,
	dxApi,
	DX_URLS,

	dxDebounce,
	dxLocalize
) {
	"use strict";

	var self = this;

	var debouncer = dxDebounce();

	self.invigilatorState = {
		EXISTING: "existing",
		NEW: "new",
		DELETED: "deleted",
	};

	self.DX_INVIGILATOR_SETTINGS = DX_INVIGILATOR_SETTINGS;
	self.DX_INVIGILATOR_LOCATION_CONSTANTS = DX_INVIGILATOR_LOCATION_CONSTANTS;

	self.settings = self.DX_INVIGILATOR_SETTINGS.NONE;

	self.invigilators = [];

	self.emailValid = false;

	self.errorMessage = "";

	self.tempState = {
		email: "",
		examId: "",
	};

	self.$onInit = function onInit() {
		if (self.examId) {
			dxApi.v1.exams.shares.recipients.get(self.examId).then(populateInvigilators, invigilatorFail);
		}
	};

	var watcher = $scope.$watch("vm.doSave", function doSave() {
		if (!self.doSave) {
			return;
		}

		if (!self.examId) {
			throw new Error("Trying to do save without an examId");
		}

		var promises = [];
		if (self.invigilators.length) {
			promises.concat(updateAllInvigilatorSettings());
			for (var i = 0; i < self.invigilators.length; i++) {
				var invigilator = self.invigilators[i];
				if (invigilator.state === self.invigilatorState.DELETED) {
					promises.push(removeInvigilatorShare(invigilator));
				} else if (invigilator.state === self.invigilatorState.NEW) {
					promises.push(createNewInvigilatorShare(invigilator));
				}
			}
		}

		$q.all(promises).then(function resolveAllPost() {
			watcher();
			self.saveCallbackFunction(true);
		});
	});

	function createNewInvigilatorShare(invigilator) {
		invigilator.objectId = self.examId;
		invigilator.data = [self.settings.toString()];
		return $http.post(DX_URLS.get("share"), invigilator);
	}

	function removeInvigilatorShare(invigilator) {
		return dxApi.v1.exams.shares.recipients.delete(self.examId, invigilator.id);
	}

	function updateAllInvigilatorSettings() {
		var promises = [];
		if (self.invigilators) {
			self.invigilators.forEach(function updateSettings(invigilator) {
				if (invigilator.state === self.invigilatorState.EXISTING) {
					var req = {
						settings: [self.settings.toString()],
						userID: invigilator.id,
					};
					promises.push(dxApi.v1.exams.shares.data.put(self.examId, req));
				}
			});
		}
		return promises;
	}

	function populateInvigilators(response) {
		var responseUsers = response.data.users;
		for (var i = 0; i < responseUsers.length; i++) {
			var invigilator = responseUsers[i];
			invigilator.state = self.invigilatorState.EXISTING;
			self.invigilators.push(invigilator);
			if (i === 0) {
				var parseSettings = parseInt(responseUsers[0].shareData[0], 10);
				if (parseSettings) {
					self.settings = parseSettings;
				}
			}
		}
	}

	function invigilatorFail() {
		self.errorMessage = dxLocalize.get("Invigilator.Error.LoadError");
	}

	self.inviteInvigilator = function inviteInvigilator() {
		var email = self.tempState.email.toLowerCase();

		for (var i = 0; i < self.invigilators.length; i++) {
			if (self.invigilators[i].email === email) {
				if (self.invigilators[i].state === self.invigilatorState.DELETED) {
					self.invigilators[i].state = self.invigilatorState.NEW;
					self.tempState.email = "";
					self.emailValid = false;
					return;
				}

				break;
			}
		}

		var newInvigilator = {
			objectId: self.tempState.examId,
			email: email,
			permission: PermissionShareEnum.LIVE_EXAM,
		};

		self.verifyEmail();
		if (!self.emailValid) {
			return;
		}

		self.tempState.email = "";
		self.emailValid = false;

		if (self.location === DX_INVIGILATOR_LOCATION_CONSTANTS.LIVE_VIEW) {
			newInvigilator.objectId = self.examId;
			newInvigilator.data = [self.settings.toString()];
			$http.post(DX_URLS.get("share"), newInvigilator).then(function success(response) {
				var invigilator = {
					email: response.data.email,
					id: response.data.id,
					state: self.invigilatorState.EXISTING,
				};
				self.invigilators.push(invigilator);
			}, function failed() {
				self.errorMessage = dxLocalize.get("Invigilator.Error.CreateError");
			});
		} else {
			newInvigilator.state = self.invigilatorState.NEW;
			self.invigilators.push(newInvigilator);
		}
	};

	self.toggleConfirmDeleteOfInvigilator = function toggleConfirmDelete(invigilator) {
		self.invigilatorAboutToBeDeleted = invigilator;
	};

	self.removeInvigilator = function removeInvigilator(invigilator) {
		self.invigilatorAboutToBeDeleted = "";
		if (self.location === DX_INVIGILATOR_LOCATION_CONSTANTS.LIVE_VIEW) {
			for (var j = 0; j < self.invigilators.length; j++) {
				if (self.invigilators[j].email === invigilator.email) {
					removeInvigilatorShare(invigilator);
					self.invigilators.splice(j, 1);
					break;
				}
			}
		} else {
			for (var i = 0; i < self.invigilators.length; i++) {
				if (self.invigilators[i].email === invigilator.email) {
					if (self.invigilators[i].state === self.invigilatorState.EXISTING) {
						self.invigilators[i].state = self.invigilatorState.DELETED;
					} else {
						self.invigilators.splice(i, 1);
					}
					break;
				}
			}
		}

		self.verifyEmail();
	};

	self.keypress = function onKeyPress() {
		debouncer.debounce(500).then(function successes() {
			self.verifyEmail();
		}, angular.noop);
	};

	self.verifyEmail = function verifyEmail() {
		if (!self.tempState.email) {
			self.emailValid = false;
			return;
		}

		var emailValid = validationService.isEmailValid(self.tempState.email, true);
		var invigilatorExist = invigilatorExists(self.tempState.email);

		if (!emailValid) {
			self.errorMessage = dxLocalize.get("Invigilator.Error.InvalidEmail");
		} else if (invigilatorExist) {
			self.errorMessage = dxLocalize.get("Invigilator.Error.AlreadyExists");
		} else {
			self.errorMessage = "";
		}

		self.emailValid = emailValid && !invigilatorExist;
	};

	self.isSettingEnabled = function isSettingEnabled(setting) {
		return (self.settings & setting);
	};

	self.toggleSetting = function toggleSetting(setting) {
		if (self.isSettingEnabled(setting)) {
			self.settings -= setting;
		} else {
			self.settings += setting;
		}
		if (self.location === DX_INVIGILATOR_LOCATION_CONSTANTS.LIVE_VIEW) {
			updateAllInvigilatorSettings();
		}
	};

	self.invigilatorListEmpty = function invigilatorListEmpty() {
		for (var i = 0; i < self.invigilators.length; i++) {
			if (self.invigilators[i].state !== self.invigilatorState.DELETED) {
				return false;
			}
		}
		return true;
	};

	function invigilatorExists(email) {
		return self.invigilators.some(function searchInvigilator(invigilator) {
			return invigilator.email === email.toLowerCase() && invigilator.state !== self.invigilatorState.DELETED;
		});
	}
});
